import { render } from "./HasAnotherResults.vue?vue&type=template&id=7fa455c2&scoped=true"
import script from "./HasAnotherResults.vue?vue&type=script&lang=js"
export * from "./HasAnotherResults.vue?vue&type=script&lang=js"

import "./HasAnotherResults.vue?vue&type=style&index=0&id=7fa455c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa455c2"]])

export default __exports__